import { HUBS, getMarketingPage } from "@/lib/seo/pages";
import type { MarketingHub } from "@/lib/seo/pages";
import type { BreadcrumbItem } from "@/lib/seo/schema";

const HOME: BreadcrumbItem = { name: "Home", href: "/" };

const STATIC_PAGES: Record<string, string> = {
  "/reviews": "Reviews",
  "/affiliate": "Affiliate Program",
  "/content-rewards": "Content Rewards",
  "/ios": "iOS App",
};

const hubTrail = (hub: MarketingHub): BreadcrumbItem[] =>
  hub.kind === "tool"
    ? [
        { name: HUBS.feature.label, href: HUBS.feature.path },
        { name: hub.label, href: hub.path },
      ]
    : [{ name: hub.label, href: hub.path }];

export const breadcrumbsForPath = (path: string): BreadcrumbItem[] => {
  const hub = Object.values(HUBS).find((candidate) => candidate.path === path);
  if (hub) return [HOME, ...hubTrail(hub)];
  if (STATIC_PAGES[path]) return [HOME, { name: STATIC_PAGES[path], href: path }];

  const page = getMarketingPage(path);
  if (!page) return [HOME];

  return [HOME, ...hubTrail(HUBS[page.kind]), { name: page.title, href: page.path }];
};
